export default {
  bind(el, binding, vnode) {
    const { value } = binding;

    // 点击事件处理函数
    const handleClick = (event) => {
      // 如果路由为 /creatStory 且指令的值为 true，则阻止点击
      if (vnode.context.$route.path === '/creatStory' && value) {
        console.log(event.target.textContent.trim().includes('编辑'))
        if(event.target.textContent.trim().includes('编辑')){
        
        }else{
          event.stopImmediatePropagation();
          event.preventDefault();
        }
        // if (['编辑','新增','删除'].includes(event.target.textContent.trim())) {
          // event.stopImmediatePropagation();
          // event.preventDefault();
        // }
      }
    };

    el.__vueClickHandler__ = handleClick;
    // 添加事件监听器，使用事件冒泡模式
    el.addEventListener('click', handleClick,true);
  },
  unbind(el) {
    el.removeEventListener('click', el.__vueClickHandler__);
    delete el.__vueClickHandler__;
  }
};